import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import "./App.css"
import { Route, Routes } from "react-router-dom"
import { connect } from "react-redux"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Import Routes all
import { adminRoutes, userRoutes, authRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

import fakeBackend from "./helpers/AuthType/fakeBackend"
import WorkingLayout from "components/WorkingLayout"
import { getUserTokenRole, parseJwt } from "utilities/parse-jwt"
import { fetchUserRoleFromToken, userData } from "redux/slice/user/userSlice"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { SHUK_AUTH_PORTAL_TOKEN } from "redux/enums"
import { allChatsData, SetCurrentStaff } from "redux/slice/chats/chatSlice"

// Activating fake backend
fakeBackend()

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = props => {
  const dispatch = useDispatch()
  const { staffId } = useSelector(allChatsData)
  const { apiStatus } = useSelector(userData)
  const [role, setRole] = useState("")

  const findUserRole = async () => {
    let usertokenRole = await getUserTokenRole()
    console.log("Role detected: ", usertokenRole)
    setRole(usertokenRole)
  }

  const settingIdForCurrentUser = async () => {
    const token = localStorage.getItem(SHUK_AUTH_PORTAL_TOKEN)
    let parsedToken = await parseJwt(token)
    let _staffId =
      parsedToken?.[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
      ]
    dispatch(SetCurrentStaff(_staffId))
  }

  useEffect(()=>{
    if(staffId === ""){
      settingIdForCurrentUser()
    }
    if(apiStatus === false){
      findUserRole()
    }
  }, [apiStatus])

  useEffect(() => {
    dispatch(fetchUserRoleFromToken())
  }, [dispatch])
  
  // {alert('hiii')}
  //   useEffect(() => {
  //     alert('hii')
  //     document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  //   }, [])

  // function getLayout() {
  //   let layoutCls = WorkingLayout

  //   switch (props.layout.layoutType) {
  //     case "horizontal":
  //       layoutCls = HorizontalLayout
  //       break
  //     default:
  //       layoutCls = VerticalLayout
  //       break
  //   }
  //   return layoutCls
  // }

  // const Layout = getLayout()
  return (
    <React.Fragment>
      <div>
        <ToastContainer />
      </div>
      <Routes>
        {/* Non-authenticated routes */}
        {authRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
          />
        ))}

        {/* Authenticated routes */}
        {role === "Admin" || role === "Viewer" ? adminRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware>
                {/* <Layout>{route.component}</Layout> */}
                <WorkingLayout>{route.component}</WorkingLayout>
              </Authmiddleware>
            }
          />
        )) : userRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware>
                {/* <Layout>{route.component}</Layout> */}
                <WorkingLayout>{route.component}</WorkingLayout>
              </Authmiddleware>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
